export default defineNuxtLink({
  componentName: 'CustomLink',
  activeClass: 'bg-gray-200 font-bold',
  exactActiveClass: 'bg-green-200 font-medium'
})
